'use strict';
(() => {
  function mount(root) {
    if (!root || root.dataset.coMounted) return;
    root.dataset.coMounted = 'true';
    const menu = root.querySelector('#menu-dialog');
    const trigger = root.querySelector('.menu-trigger');
    const detail = root.querySelector('#detail-dialog');
    if (!menu || !trigger || !detail) return;
    let returnFocus = null;
    const syncLock = () => document.body.classList.toggle('modal-open', menu.open || detail.open);
    const closeMenu = () => menu.close();
    const show = dialog => { dialog.showModal(); syncLock(); };

    trigger.addEventListener('click', () => {
      trigger.setAttribute('aria-expanded', 'true');
      show(menu);
    });
    menu.querySelector('[data-menu-close]').addEventListener('click', closeMenu);
    menu.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      syncLock();
      if (!menu.dataset.anchorNavigation) trigger.focus({ preventScroll: true });
      delete menu.dataset.anchorNavigation;
    });
    menu.querySelectorAll('nav a').forEach(link => link.addEventListener('click', event => {
      const anchor = link.getAttribute('href');
      const target = anchor?.startsWith('#') ? document.getElementById(anchor.slice(1)) : null;
      if (!target) return;
      event.preventDefault();
      menu.dataset.anchorNavigation = 'true';
      closeMenu();
      syncLock();
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }));
    root.querySelectorAll('.detail-zoom').forEach(button => button.addEventListener('click', () => {
      returnFocus = button;
      root.querySelector('#detail-title').textContent = button.dataset.detailTitle;
      const image = root.querySelector('#detail-image');
      image.src = button.dataset.detailSrc;
      image.alt = button.querySelector('img').alt;
      show(detail);
    }));
    detail.querySelector('[data-detail-close]').addEventListener('click', () => detail.close());
    detail.addEventListener('close', () => { syncLock(); returnFocus?.focus({ preventScroll: true }); });
    [menu, detail].forEach(dialog => dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const b = dialog.getBoundingClientRect();
      if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();
    }));
    // Close the mobile dialog when crossing to desktop so focus is not trapped off screen.
    const desktop = matchMedia('(min-width: 821px)');
    const onResize = event => { if (event.matches && menu.open) closeMenu(); };
    desktop.addEventListener('change', onResize);
    root.coCleanup = () => {
      desktop.removeEventListener('change', onResize);
      menu.close();
      detail.close();
      document.body.classList.remove('modal-open');
    };
  }
  document.querySelectorAll('.co-landing-root').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    mount(event.target.matches('.co-landing-root') ? event.target : event.target.querySelector('.co-landing-root'));
  });
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.matches('.co-landing-root') ? event.target : event.target.querySelector('.co-landing-root');
    root?.coCleanup?.();
  });
})();
